import { useEffect, useState } from "react";
import Modal from "@/components/base/Modal";

interface SuspendSaleModalProps {
  open: boolean;
  onClose: () => void;
  processing: boolean;
  itemCount: number;
  total: number;
  onConfirm: (label: string) => void;
}

export default function SuspendSaleModal({
  open,
  onClose,
  processing,
  itemCount,
  total,
  onConfirm,
}: SuspendSaleModalProps) {
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!open) return;
    setLabel("");
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Suspender venta"
      subtitle="Guarda el carrito actual para retomarlo más tarde sin perderlo."
      size="sm"
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-700 hover:bg-background-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => onConfirm(label.trim() || `Venta de ${itemCount} línea(s)`)}
            disabled={processing}
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 disabled:opacity-60"
          >
            {processing ? (
              <i className="ri-loader-4-line animate-spin text-base"></i>
            ) : (
              <i className="ri-pause-circle-line text-base"></i>
            )}
            Suspender
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between rounded-lg border border-background-200 bg-background-100 px-4 py-3">
          <span className="text-sm text-foreground-600">
            {itemCount} línea(s) en el carrito
          </span>
          <span className="font-heading text-lg font-bold text-primary-600">
            {new Intl.NumberFormat("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total)}{" "}
            RD$
          </span>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-foreground-700">Nombre o referencia (opcional)</label>
          <input
            value={label}
            onChange={(event) => setLabel(event.target.value)}
            maxLength={80}
            placeholder="Ej: Cliente Juan, Mesa 2..."
            className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-950 outline-none focus:border-primary-400"
          />
        </div>
      </div>
    </Modal>
  );
}